<template>
  <v-card flat class="r5">
    <v-container grid-list-md fluid :class="classProp">
      <v-layout row wrap justify-space-between>
        <div
          class="
            di-flex
            align-center
            flex
            xs12
            font-weight-bold
            px-3
            py-2
            text-xs-left
            mb-3
          "
        >
          <span> {{ $t("a2a_form") }} :</span>
          <v-divider class="ml-2" />
        </div>
        <v-flex xs12 :md6="!edit" class="pt-4">
          <v-layout row wrap>
            <v-date
              :clearable="false"
              format="YYYY-MM-DD"
              v-model="value.date"
              class="flex xs12 sm6"
              value-type="YYYY-MM-DD"
              :placeholder="$t('date')"
              input_id="a2a_tranfser_date"
              @input="$emit('date-changed')"
              :disabled-date="disableBackDate"
            />
            <v-date
              type="time"
              label="time"
              format="HH:mm:ss"
              :clearable="false"
              v-model="value.time"
              value-type="HH:mm:ss"
              class="flex xs12 sm6"
              :placeholder="$t('time')"
              input_id="a2a_transfer_time"
              :disabled-time="disableBackDate"
            />
            <v-autocomplete
              outline
              autofocus
              item-value="id"
              placeholder=" "
              persistent-hint
              item-text="name"
              :items="senders"
              v-validate="'required'"
              :data-vv-name="'sender'"
              v-model="value.sender_id"
              @change="changeFormNumber()"
              :label="$t('sender_account')"
              class="flex xs12 sm6 right-hint"
              :data-vv-as="$t('sender_account')"
              :error-messages="errors.collect('sender_account')"
              :hint="
                senderAccountBalance
                  | currency({ symbol: smbl(value.buy_currency_id) })
              "
            >
              <template v-slot:item="data">
                <v-list-tile-avatar>
                  <img :src="data.item.image" />
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title
                    v-html="data.item.full_name"
                  ></v-list-tile-title>
                  <v-list-tile-sub-title
                    v-html="$t(data.item.type)"
                  ></v-list-tile-sub-title>
                </v-list-tile-content>
              </template>
            </v-autocomplete>
            <v-autocomplete
              outline
              item-value="id"
              placeholder=" "
              persistent-hint
              item-text="name"
              :items="receivers"
              v-validate="'required'"
              @change="setDescription"
              v-model="value.receiver_id"
              :label="$t('receiver_account')"
              class="flex xs12 sm6 right-hint"
              :data-vv-name="'receiver_account'"
              :data-vv-as="$t('receiver_account')"
              :error-messages="errors.collect('receiver_account')"
              :hint="
                receiverAccountBalance
                  | currency({ symbol: smbl(value.buy_currency_id) })
              "
            >
              <template v-slot:item="data">
                <v-list-tile-avatar>
                  <img :src="data.item.image" />
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title
                    v-html="data.item.full_name"
                  ></v-list-tile-title>
                  <v-list-tile-sub-title
                    v-html="$t(data.item.type)"
                  ></v-list-tile-sub-title>
                </v-list-tile-content>
              </template>
            </v-autocomplete>

            <!-- <v-autocomplete
              outline
              placeholder=" "
              item-value="id"
              item-text="name"
              :items="currencies"
              class="flex xs12 sm6"
              v-validate="'required'"
              :label="$t('currency')"
              :data-vv-name="'currency'"
              :data-vv-as="$t('currency')"
              @change="amountChanged(false)"
              v-model="value.receiver_currency_id"
              :error-messages="errors.collect('currency')"
            /> -->
            <v-text-field
              outline
              persistentHint
              placeholder=" "
              :label="$t('amount')"
              v-model="value.amount"
              v-validate="'required'"
              :data-vv-name="'amount'"
              :data-vv-as="$t('amount')"
              :hint="value.amount | toWord"
              @input="amountChanged(false)"
              v-currency="{ currency: null }"
              class="flex xs12 sm6 mb-3 capitalize"
              :error-messages="errors.collect('amount')"
            />
            <v-autocomplete
              outline
              placeholder=" "
              item-value="id"
              item-text="name"
              :items="currencies"
              class="flex xs12 sm6 mb-3"
              v-validate="'required'"
              :label="$t('currency')"
              @change="currencyChanged"
              :data-vv-name="'currency'"
              v-model="value.currency_id"
              :data-vv-as="$t('currency')"
              :error-messages="errors.collect('currency')"
            />
            <v-combobox
              outline
              placeholder=" "
              :label="$t('risk_profile')"
              v-model="value.risk_category"
              :items="['Low', 'Medium', 'High']"
              class="flex xs12 mb-3 capitalize"
            />
            <!-- <v-text-field
              outline
              type="number"
              placeholder=" "
              class="flex xs12 sm6"
              :label="$t('amount')"
              v-validate="'required'"
              v-model="value.exchanged"
              :data-vv-as="$t('amount')"
              :data-vv-name="'exchanged'"
              @input="amountChanged(true)"
              :error-messages="errors.collect('exchanged')"
            /> -->
            <!-- <v-text-field
              outline
              type="number"
              placeholder=" "
              :label="$t('rate')"
              class="flex xs12"
              v-model="value.rate"
              v-validate="'required'"
              :data-vv-name="'rate'"
              :data-vv-as="$t('rate')"
              @input="amountChanged(false)"
              :error-messages="errors.collect('rate')"
            /> -->
            <v-textarea
              outline
              rows="0"
              auto-grow
              placeholder=" "
              class="flex xs12"
              :label="$t('description')"
              v-model="value.description"
            />
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 mt-2>
              <v-btn
                dark
                raised
                @click="save"
                color="primary"
                :loading="loading"
              >
                {{ $t("save") }}
              </v-btn>
              <v-btn
                dark
                outline
                class="mx-0"
                color="primary"
                :loading="loading"
                @click="save(false)"
                :title="$t('save_print')"
              >
                <v-icon class="mx-2">print</v-icon>
              </v-btn>
              <v-btn
                dark
                raised
                outline
                v-if="!edit"
                @click="reset"
                color="primary"
                :loading="loading"
                :title="$t('new_record')"
              >
                <v-icon class="mx-1">mdi-refresh</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 :md4="!edit" class="mt-3 hidden-sm-and-down">
          <v-layout row wrap class="justify-center mb-3">
            <v-flex xs12 class="di-flex align-center justify-space-between">
              <div class="caption">
                <strong>{{ $t("files") }}</strong>
                <br />
                {{ $t("file_max_notation") }}
              </div>
              <file-chooser text color="secondary" v-model="value.files" />
            </v-flex>
            <v-flex
              xs12
              v-if="value.files && value.files.length > 0"
              class="mt-3"
            >
              <file-viewer :files="value.files" />
            </v-flex>
          </v-layout>
          <customer-tile :customer="sender" v-if="!edit" />
          <customer-tile :customer="receiver" class="mt-3" v-if="!edit" />
        </v-flex>
        <!-- <customer-tile
          :customer="receiver"
          class="flex xs12 md4 mt-3 hidden-sm-and-down"
        /> -->
        <v-flex xs12 sm5 v-show="false">
          <transfer-bill
            v-bind="{ transfer: { ...value, exchanged }, sender, receiver }"
            ref="bill"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import { customersMixin, printBill, exchange } from "@/mixins/index.js";
import curjs from "currency.js";

export default {
  name: "a2aTransferForm",
  mixins: [customersMixin, printBill, exchange],
  props: {
    edit: { default: false },
    classProp: { default: "" },
    value: { type: Object },
  },

  data: () => ({
    loading: false,
    customers:[]
  }),

  computed: {
    currencies: (vm) => vm.initialData.currencies,
    // customers: (vm) =>
    //   vm.initialData.customers.filter(
    //     (x) =>
    //       x.type != "DailyProfit" && x.type != "external" && x.type != "stock"
    //   ),

    system() {
      let system = this.initialData.customers.find((x) => x.type == "system");
      return system ? system : {};
    },

    senders: (vm) => vm.customers,
    sender: (vm) =>
      vm.customers.find((x) => x.id == vm.value.sender_id) || { accounts: [] },

    receivers() {
      let items = this.customers.filter((x) => x.id != this.value.sender_id);
      if (this.sender.type == "income")
        return items.filter(
          (x) => x.type == "income" || x.type == "shareholder"
        );
      if (this.sender.type == "expense")
        return items.filter((x) => x.type == "expense" || x.type == "staff");
      // else if (this.sender.is_bank || this.sender.type == "branch")
      //   items = items.filter((x) => x.is_bank || x.type == "branch");
      else if (!this.sender.is_bank && this.sender.type != "asset")
        return items.filter((x) => !x.is_bank);
      return items;
    },

    receiver: (vm) =>
      vm.customers.find((x) => x.id == vm.value.receiver_id) || {
        accounts: [],
      },

    fromCurrency() {
      let currency = this.currencies.find(
        (x) => x.id === this.value.currency_id
      );
      return currency ? currency : { rank: 1, name: "" };
    },

    toCurrency() {
      let currency = this.currencies.find(
        (x) => x.id === this.value.receiver_currency_id
      );
      return currency ? currency : { rank: 1, name: "" };
    },

    senderAccountBalance() {
      let a = this.sender.accounts.find(
        (x) => x.currency_id == this.value.currency_id
      ) || { balance: 0 };
      return a.balance;
    },

    receiverAccountBalance() {
      let a = this.receiver.accounts.find(
        (x) => x.currency_id == this.value.receiver_currency_id
      ) || { balance: 0 };
      return a.balance;
    },

    exchanged: (vm) =>
      vm.exchange(
        vm.fromCurrency,
        vm.toCurrency,
        vm.value.amount,
        vm.value.rate
      ),
  },

  methods: {
    setDescription() {
      if (!this.generate_description) return;
      this.value.description = `${this.$t("transfered_from")} ${
        this.sender.name
      }  ${this.$t("transfered_to")} ${this.receiver.name} `;
    },

    reset() {
      this.$emit("reset");
      this.loading = false;
      this.$validator.reset();
    },

    changeFormNumber() {
      this.value.number = Number(this.sender.last_form_number) + 1;
      this.setDescription();
    },

    currencyChanged() {
      this.value.receiver_currency_id = this.value.currency_id;
      this.value.rate = 1;
      this.amountChanged(false);
    },

    amountChanged(is_second) {
      if (is_second) {
        this.value.amount = this.exchange(
          this.toCurrency,
          this.fromCurrency,
          curjs(this.value.exchanged).value,
          this.value.rate
        );
      } else {
        this.value.exchanged = this.exchange(
          this.fromCurrency,
          this.toCurrency,
          curjs(this.value.amount).value,
          this.value.rate
        );
      }
      this.setDescription();
    },

    save(disablePrint = true) {
      this.loading = true;
      this.$validator.validateAll().then((succeed) => {
        if (succeed) {
          this.value.amount = curjs(this.value.amount).value;
          this.value.exchanged = curjs(this.value.exchanged).value;
          this.value.number = Number(this.sender.last_form_number) + 1;
          this.axios
            .post("transfers", this.value)
            .then(async (res) => {
              let fils = this.value.files.filter((x) => !x.id);
              if (fils.length > 0) {
                const fd = new FormData();
                fd.append("fileable_type", "transfer");
                fd.append("fileable_id", res.data.id);
                for (const file of fils) {
                  fd.append("files[]", file);
                }
                await this.axios.post("files", fd, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                });
              }
              this.value.id = res.data.id;
              this.value.time = res.data.time;
              this.value.date = res.data.date;
              await this.getCustomers();
              this.printBill(this.$refs.bill.$el, disablePrint);
              this.$store.commit("showSnackbar", {
                text: this.$t("save_succeed"),
                stateType: "success",
                show: true,
              });
              this.$emit("saved", res.data);
              this.loading = false;
              this.reset();
            })
            .catch((error) => {
              console.error(error);
              this.$store.commit("showSnackbar", {
                text: error.response.data.message,
                stateType: "error",
                show: true,
              });
              this.loading = false;
            });
        } else {
          this.$store.commit("showSnackbar", {
            text: this.$t("wrong_input"),
            stateType: "error",
            show: true,
          });
          this.loading = false;
        }
      });
    },
  },
  created(){
     this.axios
        .get(
          `/transfers/create?a2a=true`
        )
        .then(({ data }) => {
          this.loading = false;
          this.customers = data.data ? data.data : data; 
        })
        .catch(() => {
          this.loading = false;
        });
  }
};
</script>
